import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import SeoIntroSection from "./components/SeoIntroSection";
import CategoryGrid from "./components/CategoryGrid";
import ArticleCenter from "./components/ArticleCenter";
import Testimonials from "./components/Testimonials";
import CtaSection from "./components/CtaSection";
import HomeFooter from "./components/HomeFooter";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <SeoIntroSection />
      <CategoryGrid />
      <ArticleCenter />
      <Testimonials />
      <CtaSection />
      <HomeFooter />
    </main>
  );
}